import React, { useState } from "react";
import { CheckCircle2, Loader2, PhoneCall } from "lucide-react";
import { toast } from "./ui/sonner";
import { useApp } from "../context/AppContext";

/* 铃铛内联：公海按规则分配给我的客户 → 每位客户一键「已联系」（记录首次 / 最近联系时间 + 跟进记录，阶段不变）；全部联系后铃铛自动已读 */
export const PoolAssignedInline = ({ reminder, compact = false, onAllDone }) => {
  const { api, lang } = useApp();
  const zh = lang === "zh";
  const leads = reminder.leads || (reminder.leadIds || []).map((id) => ({ id, clientName: id }));
  const [done, setDone] = useState(new Set(reminder.contactedIds || []));
  const [busy, setBusy] = useState(null);
  if (!leads.length) return null;
  const mark = async (e, lead) => {
    e.stopPropagation();
    setBusy(lead.id);
    try {
      const { data } = await api.post(`/crm/leads/${lead.id}/mark-contacted`, { reminderId: reminder.id });
      const next = new Set(data.contactedIds || [...done, lead.id]);
      setDone(next);
      toast.success(zh ? `${lead.clientName} 已标记为已联系` : `${lead.clientName} marked contacted`);
      if (data.allDone || next.size >= leads.length) onAllDone?.();
    } catch (err) { toast.error(err?.response?.data?.detail || err.message); }
    setBusy(null);
  };
  return (
    <div className="flex flex-wrap gap-1" data-testid={`pool-assigned-inline-${reminder.id}`} data-done={done.size} data-total={leads.length} onClick={(e) => e.stopPropagation()}>
      {leads.map((l) => done.has(l.id) ? (
        <span key={l.id} className={`inline-flex items-center gap-1 rounded-full border border-emerald-200 bg-emerald-50 text-emerald-700 ${compact ? "text-[10px] px-1.5 py-0.5" : "text-[11px] px-2 py-0.5"}`} data-testid={`pool-assigned-done-${l.id}`}><CheckCircle2 className="h-3 w-3" />{l.clientName}</span>
      ) : (
        <button key={l.id} type="button" disabled={busy === l.id} onClick={(e) => mark(e, l)} title={zh ? "标记为已联系（记录联系时间 + 跟进）" : "Mark contacted"}
          className={`inline-flex items-center gap-1 rounded-full border border-slate-200 bg-white text-slate-700 hover:border-emerald-300 hover:bg-emerald-50 disabled:opacity-50 ${compact ? "text-[10px] px-1.5 py-0.5" : "text-[11px] px-2 py-0.5"}`} data-testid={`pool-assigned-mark-${l.id}`}>
          {busy === l.id ? <Loader2 className="h-3 w-3 animate-spin" /> : <PhoneCall className="h-3 w-3 text-slate-400" />}{l.clientName}<span className="text-emerald-700 font-semibold">{zh ? "· 已联系" : "· contacted"}</span>
        </button>
      ))}
    </div>
  );
};
